class QuickActionsConstants {
  static actionCategories = ['schedule', 'crm', 'payments', 'other'];
}

export default QuickActionsConstants;
